import React, { useEffect } from "react";
import "./Login.css";
import { signInPopup } from "../utils/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGoogle,
  faTwitter,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";

function Login() {
  document.title = "Login to unknown sender"
  return (
    <>
      <div className="container">
        <div className="form">
          <div className="brand">WELCOME TO UNKNOWN SENDER</div>
          <div className="sign-in-method">
            <button onClick={() => signInPopup("google")}>
              Sign In With Google <FontAwesomeIcon icon={faGoogle} />
            </button>
            <button onClick={() => signInPopup("twitter")}>
              Sign In With Twitter <FontAwesomeIcon icon={faTwitter} />
            </button>
            <button onClick={() => signInPopup("facebook")}>
              Sign In With Facebook <FontAwesomeIcon icon={faFacebook} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
